module.exports = __webpack_public_path__ + "static/media/6. Vivi.58954e56.png";